import axios, { AxiosResponse } from 'axios'

import { EsusCadastroContexto, EsusCadastroResultado } from './_models'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Envio manual da Ficha de Cadastro Individual por paciente (F7b).
 *
 * As duas rotas são protegidas por `hasPermission(#id, 'Paciente', 'Esus:cadastro')`: o backend é a
 * autoridade real e escopa tudo pelo tenant do paciente. O cliente **não** manda empresa nem unidade
 * — mandar seria oferecer uma alavanca de tenant que o servidor de todo modo ignora.
 */
const esusCadastroUrl = (pacienteId: number) => `${API_URL}/pacientes/${pacienteId}/esus-cadastro`

/**
 * `GET /pacientes/{id}/esus-cadastro` — lotações **ativas** do profissional autenticado.
 *
 * Devolve 200 com `lotacoes: []` quando não há nenhuma; lista vazia não é erro e a tela precisa
 * explicar isso em vez de mostrar falha.
 */
export const getContextoEsusCadastro = (pacienteId: number): Promise<EsusCadastroContexto> => {
  return axios
    .get(esusCadastroUrl(pacienteId))
    .then((d: AxiosResponse<EsusCadastroContexto>) => d.data)
}

/**
 * `POST /pacientes/{id}/esus-cadastro` com corpo `{ lotacaoId }`.
 *
 * O id vai no **corpo** (`@RequestBody EsusCadastroEnvioDto`), ao contrário do PATCH de lotação da
 * E5d, que usa query param. Trocar os dois é erro silencioso: aqui viraria 400 de corpo ausente.
 *
 * 422 (`$.data.errors.lotacaoId[0]`) para lotação inválida, inativa, de outro profissional ou de
 * outro tenant, unidade sem CNES e unidade sem integração ativa — todos acionáveis pelo usuário.
 */
export const enviarEsusCadastro = (
  pacienteId: number,
  lotacaoId: number
): Promise<EsusCadastroResultado> => {
  return axios
    .post(esusCadastroUrl(pacienteId), { lotacaoId })
    .then((d: AxiosResponse<EsusCadastroResultado>) => d.data)
}
